module.exports = __webpack_public_path__ + "static/media/megga-prikolice.2df16694.pdf";